module.exports = window["ag-grid-angular"];